import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { EnvironmentService } from './environment/environment.service';

@Injectable({
  providedIn: 'root'
})
export class UserecoApiService {
  // Store the maintenance mode value for the duration of the session
  private isMaintenanceModeCache: Record<number, boolean> = {};

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) {}

  getMaintenanceMode(appPath: string | undefined): Observable<boolean> {
    const appId = this.mapAppId(appPath);

    if (this.isMaintenanceModeCache[appId] !== undefined) {
      return of(this.isMaintenanceModeCache[appId]);
    }

    const baseUrl = this.environmentService
      .get('userecoApiUrl')
      ?.replace(/\/$/, '');
    const url = `${baseUrl}/applicationSettings/maintenanceMode/${appId}`;
    return this.http.get<{ isMaintenanceModeEnabled: boolean }>(url).pipe(
      map((response) => {
        const isMaintenanceModeEnabled = response.isMaintenanceModeEnabled;
        this.isMaintenanceModeCache[appId] = isMaintenanceModeEnabled;
        return isMaintenanceModeEnabled;
      })
    );
  }

  private mapAppId(appPath: string | undefined): number {
    switch (appPath) {
      case 'claim-lookup':
        return 2;
      case 'analytics':
        return 3;
      case 'reports':
        return 4;
      default:
        // fallback to shell
        return 1;
    }
  }
}
